import React from 'react';
import PropTypes from 'prop-types';
import SeatMap2D from './seat-map-container';
import SeatMapPacifa from './seat-map-pacifa';

export default function SeatMapContainer({
    mode3d = false,
    pacifaKey = null,
    zone = null,
    popoverSeat = null,
    provider,
    onSeatsSelected,
    onSeatClicked,
    resetSelection,
    endpoint,
    onHidePopup,
    idFrame,
    ...rest
}) {
    if (mode3d) {
        return (
            <SeatMapPacifa
                pacifaKey={pacifaKey}
                zone={zone}
                popoverSeat={popoverSeat}
                provider={provider}
                onSeatClicked={onSeatClicked}
                resetSelection={resetSelection}
                endpoint={endpoint}
                onHidePopup={onHidePopup}
                idFrame={idFrame}
                {...rest}
            />
        );
    }
    return (
        <SeatMap2D
            zone={zone}
            onSeatClicked={onSeatClicked}
            onSeatsSelected={onSeatsSelected}
            {...rest}
        />
    );
}

SeatMapContainer.propTypes = {
    mode3d: PropTypes.bool,
    showScene: PropTypes.bool,
    sceneLabel: PropTypes.string,
    categories: PropTypes.array.isRequired,
    zone: PropTypes.object.isRequired,
    showPopup: PropTypes.bool,
    getLabel: PropTypes.func,
    mapOptions: PropTypes.object,
    onSeatClicked: PropTypes.func,
    onSeatsSelected: PropTypes.func,
    onSeatOver: PropTypes.func,
    popover: PropTypes.any,
    minimap: PropTypes.bool,
    defaultColor: PropTypes.string,
    name: PropTypes.string,
    locale: PropTypes.string,
    pacifaKey: PropTypes.string,
    popoverSeat: PropTypes.any,
    provider: PropTypes.string,
    resetSelection: PropTypes.bool,
    endpoint: PropTypes.string,
    onHidePopup: PropTypes.func,
    idFrame: PropTypes.string,
};

SeatMapContainer.defaultProps = {
    isPacifa: false,
    pacifaKey: null,
};
